<!-- Main Content -->
<div class="dashboard-container">
  <!-- Summary Cards -->
  <div class="stats-grid">
    <!-- Clients Card -->
    <div class="stats-card">
      <div class="stats-icon">
        <img src="../../assets/group_24dp_CCCCCC_FILL0_wght400_GRAD0_opsz24.svg" alt="Clients">
      </div>
      <div class="stats-info">
        <h4>{{clientCount}}</h4>
        <p>Clients</p>
      </div>
    </div>

    <!-- Factures Card -->
    <div class="stats-card">
      <div class="stats-icon">
        <img src="../../assets/description_24dp_CCCCCC_FILL0_wght400_GRAD0_opsz24.svg" alt="Factures">
      </div>
      <div class="stats-info">
        <h4>{{intialOrderSize}}</h4>
        <p>Factures</p>
      </div>
    </div>

    <!-- Payée Card -->
    <div class="stats-card">
      <div class="stats-icon">
        <img src="../../assets/done_all_24dp_CCCCCC_FILL0_wght400_GRAD0_opsz24.svg" alt="Payée">
      </div>
      <div class="stats-info">
        <h4>MAD{{ (paymentDetails.paid || 0) | numberSuffix }}</h4>
        <p>Payée</p>
      </div>
    </div>

    <!-- Impayée Card -->
    <div class="stats-card">
      <div class="stats-icon">
        <img src="../../assets/error_24dp_CCCCCC_FILL0_wght400_GRAD0_opsz24.svg" alt="Impayée">
      </div>
      <div class="stats-info">
        <h4>MAD{{ (paymentDetails.unpaid || 0) | numberSuffix }}</h4>
        <p>Impayée</p>
      </div>
    </div>
  </div>

  <!-- Orders Section -->
  <div class="orders-section">
    <!-- Controls Bar -->
    <div class="controls-bar">
      <button (click)="openClientFormDialog()" class="create-button">
        <img src="../../assets/add_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg" alt="Create">
        <span>Create Invoice</span>
      </button>

      <div class="filters">
        <div class="search-box">
          <input type="search" (input)="onInputChange($event)" placeholder="Search Invoice">
        </div>
        <input type="date" (change)="onDateChange($event)" class="date-picker">
        <select (change)="onStatusChange($event)" class="status-select">
          <option value="">Invoice Status</option>
          <option value="true">Payée</option>
          <option value="false">Impayée</option>
        </select>
      </div>
    </div>

    <!-- Orders List -->
    <div class="orders-container">
      <!-- Desktop View -->
      <table class="orders-table desktop-view">
        <thead>
          <tr>
            <th>Client</th>
            <th>Téléphone</th>
            <th>Total</th>
            <th>État</th>
            <th>Date de création</th>
            <th class="text-end">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="isTableLoading">
            <td colspan="6" class="text-center py-3">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </td>
          </tr>
          <tr *ngFor="let order of ordersToDisplay" [class.d-none]="isTableLoading">
            <td>
              <div class="client-info">
                <div class="client-avatar">
                  {{ getClientInitials(order.clientDTO?.firstName, order.clientDTO?.lastName) }}
                </div>
                <div class="client-name">
                  {{order.clientDTO?.firstName}} {{order.clientDTO?.lastName}}
                </div>
              </div>
            </td>
            <td>{{order.clientDTO?.phoneNumber}}</td>
            <td>
              <span>MAD {{order.total}}</span>
            </td>
            <td>
              <span [class]="'status-badge ' + (isOrderPaid(order) ? 'paid' : 'unpaid')">
                {{isOrderPaid(order) ? 'Payée' : 'Impayée'}}
              </span>
            </td>
            <td>{{setOrderDate(order)}}</td>
            <td>
              <div class="action-buttons">
                <button (click)="goToOrderDetails(order)" class="action-btn view-btn" matTooltip="View">
                  <i class="fa fa-eye"></i>
                </button>
                <button (click)="goToOrderEdit(order)" class="action-btn edit-btn" matTooltip="Edit">
                  <i class="fa fa-pencil"></i>
                </button>
                <button (click)="openReturnDialog(order)" class="action-btn return-btn" matTooltip="Refund/Return" style="color: #e63946; background: #fff3f3; border-color: #ffcccc;">
                  <i class="fa fa-reply"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Mobile View -->
      <div class="mobile-view">
        <div *ngIf="isTableLoading" class="text-center py-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div class="order-card" *ngFor="let order of ordersToDisplay" [class.d-none]="isTableLoading">
          <div class="order-card-header">
            <div class="client-info">
              <div class="client-avatar">
                {{ getClientInitials(order.clientDTO?.firstName, order.clientDTO?.lastName) }}
              </div>
              <div class="client-details">
                <h3>{{order.clientDTO?.firstName}} {{order.clientDTO?.lastName}}</h3>
                <p>{{order.clientDTO?.phoneNumber}}</p>
              </div>
            </div>
            <span [class]="'status-badge ' + (isOrderPaid(order) ? 'paid' : 'unpaid')">
              {{isOrderPaid(order) ? 'Payée' : 'Impayée'}}
            </span>
          </div>
          <div class="order-card-body">
            <div class="order-info">
              <div class="info-item">
                <span class="label">Total:</span>
                <span class="value">MAD {{order.total}}</span>
              </div>
              <div class="info-item">
                <span class="label">Date:</span>
                <span class="value">{{setOrderDate(order)}}</span>
              </div>
            </div>
            <div class="order-actions">
              <button (click)="goToOrderDetails(order)" class="action-btn view-btn">
                <i class="fa fa-eye"></i> View
              </button>
              <button (click)="goToOrderEdit(order)" class="action-btn edit-btn">
                <i class="fa fa-pencil"></i> Edit
              </button>
              <button (click)="openReturnDialog(order)" class="action-btn return-btn" style="color: #e63946; background: #fff3f3; border-color: #ffcccc;">
                <i class="fa fa-reply"></i> Return
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginator -->
    <app-paginator
      [totalItems]="orderSize"
      [itemsPerPage]="ordersPerPage"
      [currentPage]="currentPage"
      [pages]="pages"
      [pagedItemsSize]="ordersToDisplay.length"
      (pageChange)="onPageChange($event)">
    </app-paginator>
  </div>
</div>
